import { create } from 'zustand';

type EmbedStore = {
  embedToken: string | null;
  setEmbedToken: (embedToken: string) => void;
  clearEmbedToken: () => void;
};

export const useEmbedStore = create<EmbedStore>((set) => ({
  embedToken: null,
  setEmbedToken: (embedToken) => set({ embedToken }),
  clearEmbedToken: () => set({ embedToken: null }),
}));
